var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { PreloadedImage } from 'src/common-ui/preloaded-image/preloaded-image.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export const SelectAccountSectionItemComponent = ({ item, selectedAccount, isLast, handleItemClicked, closeDropdown, setInfoMessage, dragHandle, isOnMain, }) => {
    const [hovered, setHovered] = useState(false);
    const copyUsernameToClipboard = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        event.stopPropagation();
        yield navigator.clipboard.writeText(item.value);
        closeDropdown();
        if (setInfoMessage) {
            setInfoMessage('popup_html_text_copied', [item.value]);
        }
    });
    const avatarSrc = item.avatar || `https://steemitimages.com/u/${item.label}/avatar`;
    const renderCheckedAccount = () => {
        if (isOnMain)
            return (React.createElement("div", { className: "icons-wrapper" },
                selectedAccount === item.value && !hovered && (React.createElement(SVGIcon, { icon: SVGIcons.SELECT_ACTIVE, className: "active-icon", forceHover: hovered, hoverable: true })),
                hovered && (React.createElement("div", { className: `hovered-icons ${process.env.IS_FIREFOX ? 'firefox' : ''}` },
                    React.createElement("div", { onClick: (event) => copyUsernameToClipboard(event) },
                        React.createElement(PreloadedImage, { className: 'copy-icon', src: `/assets/images/select/copy.svg` })),
                    !process.env.IS_FIREFOX && (React.createElement("span", Object.assign({}, dragHandle),
                        React.createElement(SVGIcon, { icon: SVGIcons.SELECT_DRAG, className: "drag-icon" })))))));
        else if (selectedAccount === item.value)
            return (React.createElement(SVGIcon, { icon: SVGIcons.SELECT_ACTIVE, className: "active-icon", forceHover: hovered, hoverable: true }));
    };
    return (React.createElement("div", { className: "option", onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        React.createElement("div", { "data-testid": `select-account-item-${item.value}`, className: `select-account-item ${selectedAccount === item.value ? 'selected' : ''}`, onClick: () => {
                handleItemClicked(item.value);
                closeDropdown();
            } },
            React.createElement(PreloadedImage, { className: "user-picture", src: avatarSrc, alt: '/assets/images/menu/accounts.svg', placeholder: '/assets/images/menu/accounts.svg' }),
            React.createElement("div", { className: "account-name" }, item.label),
            renderCheckedAccount()),
        !isLast && React.createElement("div", { className: "separator" })));
};
